import ProjectAttributesConfigContent from './ProjectAttributesConfigContent'

export default ProjectAttributesConfigContent
